import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, redirect } from "react-router-dom";
// import './questionnaire.css';

import Landing from './pages/Landing.jsx';
import PicklQuestionnaire from './pages/Questionnaire.jsx';
import NotFound from './pages/NotFound.jsx';
import Privacy from './pages/Privacy.jsx';
import ToS from './pages/ToS.jsx';
import AuthPage from './pages/Auth.jsx';
import Onboarding from './pages/Onboarding.jsx';
import PasswordReset from './pages/PasswordReset.jsx';
import Home from './pages/Home.jsx';
import Watchlist from './pages/Watchlist.jsx';
import Watched from './pages/Watched.jsx';
import UserSettings from './pages/UserSettings.jsx';
import Groups from "./pages/Groups.jsx";
import GroupRecommendations from "./pages/GroupRecommendations.jsx";
import { getUserInfo } from './services/api';

const router = createBrowserRouter([
  {
    path: '/',
    loader: async () => {
      try {
        await getUserInfo();
        return redirect('/home');
      } catch (e) {
        return redirect('/landing');
      }
    },
    element: null,
    errorElement: <NotFound />,
  },
  {
    path: '/landing',
    element: <Landing />,
  },
  {
    path: '/onboarding',
    element: <Onboarding />,
  },
  {
    path: '/PicklQuestionnaire/',
    element: <PicklQuestionnaire />,
  },
  {
    path: '/full-questionnaire/',
    element: <PicklQuestionnaire />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/ToS',
    element: <ToS />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/password-reset',
    element: <PasswordReset />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  // Routes for new pages (to be created)
  {
    path: '/favorites',
    element: <Watchlist />, // Watchlist component
  },
  {
    path: '/watched',
    element: <Watched />, // Watched component
  },
  {
    path: '/user-settings',
    element: <UserSettings />,
  },
  {
    path: "/groups",
    element: <Groups />,
  },
  {
    path: "/groups/:groupId/recommendations",
    element: <GroupRecommendations />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
